import * as React from 'react'
import type { PageHeaderBreadcrumbItem } from '@pushly/aqe/lib/components/page-header/page-header'
import { AppService } from '@halo/services/app.service'

export type Crumb = PageHeaderBreadcrumbItem

type ClickHandler = React.MouseEventHandler<HTMLAnchorElement | HTMLSpanElement>

/**
 * Builds a breadcrumb click handler that performs client-side navigation via
 * AppService, optionally carrying router location state derived from `stateFn`.
 *
 * `TState` is inferred from `stateFn` so each call site is type-checked against
 * the exact location-state shape it pushes (e.g. `{ account?: AccountDto }`).
 */
export function makeCrumbClick<TState extends object = never>(
    appService: AppService,
    stateFn?: () => TState,
): ClickHandler {
    return (ev) => {
        if (ev.metaKey) return
        ev.preventDefault()
        const href = ev.currentTarget.getAttribute('href')
        if (href) appService.route(href, stateFn?.())
    }
}
